//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addcopartner, isexistcopartner, getUserRealinfo } from '@/api/power';
import {
  XDialog,
  XInput,
  TransferDomDirective as TransferDom,
  Toast
} from 'vux';
import TQ from '@/utils/tianqi';
import { Button as HButton, MediaList } from '../common';

export default {
  components: {
    HButton, MediaList, XDialog, XInput, Toast
  },
  directives: {
    TransferDom
  },
  props: {
    data: {
      type: Object,
      default: (() => {}),
    }
  },
  data() {
    return {
      visiable: false,
      mobilePhone: '',
      copartnerName: '',
      toastMessage: '',
      showToast: false,
      btnDisabled: false,
      oldMobile: '',
      oldCopartnerName: '',
      scrollHeight: 0,
    };
  },
  async mounted() {
    const data = await isexistcopartner({
      cityCode: this.data.cityCode,
      adCode: this.data.adCode,
    });
    this.btnDisabled = !!data;
    // document.body.addEventListener('focusout', (e) => {
    //   console.log(33, e);
    //   // 软键盘收起的事件处理
    //   window.scrollTo(0, 0);
    // });
  },
  methods: {
    blurHandle() {
      window.scrollTo(0, 0);
    },
    // focusHandle() {
    // console.log(document.documentElement.clientHeight || document.body.clientHeight);
    // this.scrollHeight = document.querySelector('.warm-up-dialog .weui-dialog').scrollHeight;
    // },
    async clickHandle() {
      try {
        const { realName, mobile } = await getUserRealinfo();
        this.mobilePhone = mobile;
        this.copartnerName = realName;
        this.oldMobile = mobile;
        this.oldCopartnerName = realName;
        this.visiable = !this.btnDisabled;
        TQ.pageView({
          pageId: 'mask_usergrowth_power_alipay',
          categoryId: 'switchpower',
        });
      } catch (err) {
        throw new Error(err);
      }
    },
    async submitHandle() {
      TQ.clickButton({
        pageId: 'usergrowth_power_alipay',
        buttonName: 'mainbutton_click_usergrowth',
        categoryId: 'switchpower',
        businessInfo: {
          citytype: this.$store.state.user.tianqiParams.citytype,
          title: this.btnDisabled ? '已申请合作' : this.data.redirectText
        }
      });
      if (this.oldCopartnerName !== this.copartnerName && !this.checkRequire(this.copartnerName)) {
        this.toastMessage = '请填写您的姓名';
        this.showToast = true;
        return;
      }

      if (this.oldMobile !== this.mobilePhone && !this.checkRequire(this.mobilePhone)) {
        this.toastMessage = '请填写您的手机号';
        this.showToast = true;
        return;
      }
      if (this.oldMobile !== this.mobilePhone && !this.checkPhone(this.mobilePhone)) {
        this.toastMessage = '手机号格式不正确';
        this.showToast = true;
        return;
      }
      const { data: { cityCode, adCode } } = this;
      try {
        await addcopartner({
          copartnerName: this.oldCopartnerName !== this.copartnerName ? this.copartnerName : '',
          mobilePhone: this.oldMobile !== this.mobilePhone ? this.mobilePhone : '',
          cityCode,
          adCode
        });
        TQ.clickButton({
          pageId: 'mask_usergrowth_power_alipay',
          buttonName: 'submit_click_mask_usergrowth',
          categoryId: 'switchpower',
        });
        this.toastMessage = '申请合作成功';
        this.visiable = false;
        this.btnDisabled = true;
      } catch (err) {
        this.toastMessage = err.message;
      } finally {
        this.showToast = true;
      }
    },
    closeDialog() {
      this.visiable = false;
      this.copartnerName = '';
      this.mobilePhone = '';
      TQ.pageViewOut({
        pageId: 'mask_usergrowth_power_alipay',
        categoryId: 'switchpower',
      });
    },
    checkRequire(str) {
      return str.length > 0;
    },
    checkPhone(phone) {
      return /^1[3456789]\d{9}$/.test(phone);
    },
  },
};
